/*
 * @Author: zuoxuecheng
 * @Date: 2024-07-10 10:00:45
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import Vue from "vue";
import store from "../store";
import { px } from "./common";
import { showBox, userToken } from '../api/slicer/printer';
import { i18n } from "@/lang";
import { errorDialog, successDivProjectInfo, successDiv } from './dialog'
import { defaultModelImg } from './defaultImg'
import { postProjectCommentInfo } from "@/api/network/printer"
import { getQueryParam } from "@/utils/common";
import materialsAll from "@/api/materialsAll";
import { isMacOS } from '@/utils/platform'

let _that = Vue;

export function receiveTopic(topic, payload) {
  console.log(topic + "订阅响应", payload);
  let infoArr = topic.split("/");
  let modelKey = infoArr[6]; //机器key
  let data = JSON.parse(payload);
  if (infoArr.length == 11) {
    // 盒子ota
    let boxId = infoArr[9];
    if (
      data.type == "ota" &&
      data.action == "update" &&
      (data.code == 200 || data.code == 0)
    ) {
      updateBoxVersion(modelKey, boxId, data);
    }
    if (
      data.type == "ota" &&
      data.action == "cancel" &&
      (data.code == 200 || data.code == 0)
    ) {
      updateBoxCancel(modelKey, boxId, data);
    }
  } else {
    // console.log('JSON转化响应', data)
    if (data.type == "tempature" && (data.code == 200 || data.code == 0)) {
      tempature(modelKey, data);
    }
    if (data.type == "fan" && (data.code == 200 || data.code == 0)) {
      fan(modelKey, data);
    }

    if (data.type == "light" && data.action == "query" && (data.code == 200 || data.code == 0)) {
      light(modelKey, data);
    }

    if (data.type == "light" && data.action == "control" && (data.code == 200 || data.code == 0)) {
      lightControl(modelKey, data);
    }

    if (data.type == "lastWill" && (data.code == 200 || data.code == 0)) {
      lastWill(modelKey, data);
    }

    if (data.type == "print" && data.code != 200 && data.code != 0) {
      // 打印出现错误
      let curPrinter = JSON.parse(
        JSON.stringify(store.getters.GET_CUR_PRINTER)
      );
      if (curPrinter && curPrinter.key == modelKey) {
        if (data.state == "pausing") {
          console.log("进了报错pausing");
          store.dispatch("SET_LOADING_FALSE");
          curPrinter.project.pause = 2;
          store.commit("SET_CUR_PRINTER", curPrinter);
        }
        if (data.state == "paused") {
          console.log("进了报错paused");
          store.dispatch("SET_LOADING_FALSE");
          curPrinter.project.pause = 1;
          store.commit("SET_CUR_PRINTER", curPrinter);
        }
        if (data.state == 'stoped' || data.state == 'failed') {
          // 用户结束任务
          store.dispatch("SET_LOADING_FALSE");
          curPrinter.project = undefined;
          store.commit("SET_CUR_PRINTER", curPrinter);
        }
      }

      // 处理列表
      let cloudList = JSON.parse(
        JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
      );
      let idx = cloudList.findIndex((item) => modelKey == item.key);
      if (idx != -1) {
        if (data.state == "pausing") {
          console.log("进了报错pausing");
          store.dispatch("SET_LOADING_FALSE");
          cloudList[idx].project.pause = 2;
          store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
        }
        if (data.state == "paused") {
          console.log("进了报错paused");
          store.dispatch("SET_LOADING_FALSE");
          cloudList[idx].project.pause = 1;
          store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
        }
        if (data.state == 'stoped' || data.state == 'failed') {
          // 用户结束任务
          store.dispatch("SET_LOADING_FALSE");
          cloudList[idx].project = undefined;
          store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
        }
      }
      store.dispatch("SET_LOADING_FALSE");
      // return false;
    }
    if (
      data.type == "print" &&
      data.action == "update" &&
      (data.code == 200 || data.code == 0)
    ) {
      updateFun(modelKey, data);
    }

    if (
      data.type == "print" &&
      data.action == "start" &&
      (data.code == 200 || data.code == 0)
    ) {
      startFun(modelKey, data);
    }
    if (
      data.type == "print" &&
      data.action == "stop" &&
      (data.code == 200 || data.code == 0)
    ) {
      stopFun(modelKey, data);
    }
    if (
      data.type == "print" &&
      data.action == "pause" &&
      (data.code == 200 || data.code == 0)
    ) {
      pauseFun(modelKey, data);
    }
    if (
      data.type == "print" &&
      data.action == "resume" &&
      (data.code == 200 || data.code == 0)
    ) {
      resumeFun(modelKey, data);
    }
    if (
      data.type == "ota" &&
      data.action == "update" &&
      (data.code == 200 || data.code == 0)
    ) {
      updateVersion(modelKey, data);
    }
    if (
      data.type == "ota" &&
      data.action == "cancel" &&
      (data.code == 200 || data.code == 0)
    ) {
      updateCancel(modelKey, data);
    }
    // updateReport(modelKey,data)
    if (
      data.type == "status" &&
      data.action == "workReport" &&
      (data.code == 200 || data.code == 0)
    ) {
      workReport(modelKey, data);
    }
  }
  //  获取所有的topic信息，不做额外处理
  printingBefore(modelKey, topic, data);
  //  弹框逻辑（失败与成功）
  topicGetDialog(modelKey, topic, data)
  //  状态报错的额外处理
  if (data.code >= 10000 && data.code <= 19999) {
    errorAfter(modelKey, data.code)
  }
}

// 操作vuex数据
function printingBefore(modelKey, topic, data) {
  const params = {
    topic: topic,
    data: data
  };
  store.commit("SET_CUR_BEFORE_TASK", params);
}

//  弹框逻辑（失败与成功）
//  10.10 解决再打印机列表网络类型错乱的问题
async function topicGetDialog(modelKey, topic, data) {
  let errorIdData = store.getters['GET_ERROR_ID_DATA'] || {}

  const curPrinter = store.getters['GET_CUR_PRINTER']

  //  获取机器key，拿到机器name
  const printerList = store.getters.GET_CLOUD_PRINTER_LIST
  const printerListIndex = printerList.findIndex(item => item?.key == modelKey)
  const name = printerList[printerListIndex]?.name

  //  获取机器目前打印的文件
  const fileName = data?.data?.filename

  //  新增：添加 网络类型-机器id/key 

  //  新增：添加对象（机器id/key 网络类型 机器详情）
  const obj = {
    key: modelKey,
    type: 'cloud',
    obj: printerList[printerListIndex],
    code: data?.code
  }

  //  国际化
  const locale = i18n

  //  获取模型预览图
  const modelImg = modelKey === curPrinter?.key
    ? curPrinter.project?.img || defaultModelImg
    : printerList[printerListIndex]?.project?.img || defaultModelImg

  //  增加处理逻辑，当机器返回错误时，提示弹框
  if (data?.code >= 10000 && data?.code <= 19999 && errorIdData?.[modelKey] != data?.code) {
    //  获取错误码
    const errorData = JSON.parse(localStorage.getItem('error_list')) || []
    const index = errorData?.findIndex(item => item?.reason == data?.code)
    if (index != -1) {
      const msg = returnMessage(errorData?.[index])
      const wiki = errorData?.[index]?.help_url
      const dialogDiv = errorDialog({
        name,
        code: data?.code,
        fileName,
        errorTips: msg,
        url: wiki,
        isDark: store.getters.GET_IS_DARK,
        isMac: isMacOS()
      })
      //  修改错误码标题
      // const errorTitle = fileName ? locale.t('printing_error') : locale.t('operation_error')
      //  处理同样错误码报错多次的判断
      showBox(2, locale.t('error_alert'), dialogDiv, 2, `cloud-${modelKey}`, 1)
      errorIdData[modelKey] = data?.code
      store.commit('SET_ERROR_ID_DATA', errorIdData)
    }
  }

  //  增加处理逻辑，打印成功
  if (data?.state == 'finished' && data?.type == 'print' && data?.action == 'start' && !errorIdData?.[modelKey]) {
    const res = await postProjectCommentInfo({
      project_id: data.data?.taskid
    })

    if (res.code != 1) return
    const projectInfo = res.data || {}
    projectInfo.project_id = data.data?.taskid

    //  判断生产还是本地
    const prod = getQueryParam(location.hash, 'prod') || localStorage.getItem('prod')
    const fild = process.env.VUE_APP_NODE_ENV === 'anycubicSlicer' && prod === '1'
    console.log('env', fild);


    //  处理请求的baseUrl
    const baseUrl = fild
      ? '/p/p/workbench/api'
      : '/p/t/workbench/api'

    const language = i18n.locale
    projectInfo.web_markonline_comment_url = language == 'zh_CN' || language == 'zh_TW'
      ? projectInfo.web_markonline_comment_url.split('/score').join('/zh/score')
      : projectInfo.web_markonline_comment_url.split('/score').join('/en/score')
    //  处理makeronline地址
    const token = await userToken(2)
    projectInfo.web_markonline_comment_url = projectInfo.web_markonline_comment_url.replace('${taskId}', data.data?.taskid);
    projectInfo.web_markonline_comment_url = fild
      ? 'https://uc.makeronline.com/api/auth-redirect' + `?id_token_hint=${token}&target_uri=${encodeURIComponent(projectInfo.web_markonline_comment_url)}`
      : 'https://uc-mo-itdev.anycubic.com/api/auth-redirect' + `?id_token_hint=${token}&target_uri=${encodeURIComponent(projectInfo.web_markonline_comment_url)}`

    const regionCn = localStorage.getItem('regionCn')
    // projectInfo.is_markonline_file = 1
    if (regionCn && projectInfo.is_markonline_file == 1) {
      projectInfo.is_markonline_file = regionCn == 0
        ? 1
        : 0
    }

    //  提交弹框提示语国际化
    const submitTips = {
      print_quality_score: locale.t('print_quality_score'),
      submit: projectInfo.is_markonline_file ? locale.t("score_only") : locale.t("submit"),
      submitted: locale.t('submitted'),
      points: locale.t('points'),
      review_makeronlie: locale.t('review_makeronlie'),
      extra: locale.t('extra'),
      submission_failed_retry: locale.t('submission_failed_retry'),
    }

    //  国外有评分，国内无评分
    let params = {
      name,
      fileName,
      successTip: locale.t('task_completed'),
      isDark: store.getters.GET_IS_DARK,
      modelImg,
    }
    if (regionCn == 0) {
      params = Object.assign(params, {
        projectInfo,
        submitTips,
        baseUrl,
        isMac: isMacOS(),
      })
      const div = successDivProjectInfo(params)
      showBox(2, locale.t('print_finished'), div, 2, `cloud-${modelKey}`, 0)
    } else {
      const div = successDiv(params)
      showBox(2, locale.t("print_finished"), div, 2, `cloud-${modelKey}`, 1);
    }


    errorIdData[modelKey] = data?.code
    store.commit('SET_ERROR_ID_DATA', errorIdData, modelKey)
  }
}

// 操作vuex数据 更新温度
function tempature(modelKey, payload) {
  let curTask = store.getters.GET_CUR_TASK;
  if (curTask && curTask.key == modelKey) {
    console.log("进了tempature");
    if (curTask.id == payload.data.taskid) {
      curTask.temp.curr_hotbed_temp = payload.data.curr_hotbed_temp;
      curTask.temp.curr_nozzle_temp = payload.data.curr_nozzle_temp;
      curTask.temp.target_hotbed_temp = payload.data.target_hotbed_temp;
      curTask.temp.target_nozzle_temp = payload.data.target_nozzle_temp;
      store.commit("SET_CUR_TASK", curTask);
    }
  }
}

// 操作vuex数据 更新风扇
function fan(modelKey, payload) {
  let curTask = store.getters.GET_CUR_TASK;
  if (curTask && curTask.key == modelKey) {
    console.log("进了fan");
    if (curTask.id == payload.data.taskid) {
      curTask.fan_speed_pct = payload.data.fan_speed_pct;
      curTask.aux_fan_speed_pct = payload.data.aux_fan_speed_pct;
      curTask.box_fan_level = payload.data.box_fan_level;
      store.commit("SET_CUR_TASK", curTask);
    }
  }
}

// 操作vuex数据 更新风扇
function light(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));

  if (curPrinter && curPrinter.key == modelKey) {
    if (!curPrinter.light) {
      Vue.set(curPrinter, "light", {
        ledHeader: false,
        ledCamera: false,
        ledBox: false
      });
    }
    if (payload.data && payload.data.lights && Array.isArray(payload.data.lights)) {
      payload.data.lights.forEach((item) => {
        if (item.type == 1) {
          curPrinter.light.ledHeader = (item.status == 1 ? true : false)
        } else if (item.type == 2) {
          curPrinter.light.ledBox = (item.status == 1 ? true : false)
        } else if (item.type == 3) {
          curPrinter.light.ledCamera = (item.status == 1 ? true : false)
        }
      })
    }
    store.commit("SET_CUR_PRINTER", curPrinter);
  }
}

function lightControl(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));

  if (curPrinter && curPrinter.key == modelKey) {
    if (!curPrinter.light) {
      Vue.set(curPrinter, "light", {
        ledHeader: false,
        ledCamera: false,
        ledBox: false
      });
    }
    if (payload.data) {
      if (payload.data.type == 1) {
        curPrinter.light.ledHeader = payload.data.status == 1 ? true : false;
      } else if (payload.data.type == 2) {
        curPrinter.light.ledBox = payload.data.status == 1 ? true : false;
      } else if (payload.data.type == 3) {
        curPrinter.light.ledCamera = payload.data.status == 1 ? true : false;
      }
    }
    store.commit("SET_CUR_PRINTER", curPrinter);
  }
}

function lastWill(modelKey, payload) {
  console.log("进入了workReport", payload);
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
  if (curPrinter && curPrinter.key == modelKey) {
    if (payload.state == "free") {
      curPrinter.device_status = "1";
      curPrinter.is_printing = "1";
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (payload.state == "busy") {
      curPrinter.device_status = "1";
      curPrinter.is_printing = "2";
      store.commit("SET_CUR_PRINTER", curPrinter);
    }

    if (payload.state == "offline") {
      curPrinter.device_status = "2";
      curPrinter.is_printing = "";
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    if (payload.state == "free") {
      cloudList[idx].device_status = "1";
      cloudList[idx].is_printing = "1";
      cloudList = px(cloudList);
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
    if (payload.state == "busy") {
      cloudList[idx].device_status = "1";
      cloudList[idx].is_printing = "2";
      cloudList = px(cloudList);
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }

    if (payload.state == "offline") {
      cloudList[idx].device_status = "2";
      cloudList[idx].is_printing = "1";
      cloudList = px(cloudList);
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
  }
}

// 操作vuex数据 更新温度、风扇、打印模式
function updateFun(modelKey, payload) {
  let curTask = store.getters.GET_CUR_TASK;
  if (curTask && curTask.key == modelKey) {
    console.log("进了update");
    if (curTask.id == payload.data.taskid) {
      curTask.temp.curr_hotbed_temp = payload.data.curr_hotbed_temp;
      curTask.temp.curr_nozzle_temp = payload.data.curr_nozzle_temp;
      curTask.temp.target_hotbed_temp =
        payload.data.settings?.target_hotbed_temp;
      curTask.temp.target_nozzle_temp =
        payload.data.settings?.target_nozzle_temp;
      curTask.fan_speed_pct = payload.data.settings?.fan_speed_pct;
      curTask.aux_fan_speed_pct = payload.data.settings?.aux_fan_speed_pct;
      curTask.box_fan_level = payload.data.settings?.box_fan_level;
      curTask.print_speed_mode = payload.data.settings?.print_speed_mode;
      store.commit("SET_CUR_TASK", curTask);
    }
  }
}

// 操作vuex数据  开始打印
function startFun (modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
  let map = {
    printing: 1,
    finished: 2,
    failed: 3,
    downloading: 4,
    checking: 5,
    preheating: 6,
    slicing: 7,
    auto_leveling: 9,
    vibrating: 10,
    flow_calibrating: 11,
    drying: 12
  };
  if (curPrinter && curPrinter.key == modelKey) {
    console.log("进了start", payload);
    if (!curPrinter.project) {
      Vue.set(curPrinter, "project", {});
    }
    if (curPrinter.project.task_id != payload.data.taskid) {
      curPrinter.project.img = "";
    }
    if (
      payload.state == "preheating" ||
      payload.state == "printing" ||
      payload.state == "finished"
    ) {
      curPrinter.project.filename = payload.data.filename;
      // curPrinter.project.img = payload.data.img || "";
      curPrinter.project.estimate =
        (parseInt(payload.data.print_time) +
          parseInt(payload.data.remain_time)) *
        60; //
      // curPrinter.project.supplies_usage = payload.data.supplies_usage;
      curPrinter.project.pause = 0;
      curPrinter.project.print_status = map[payload.state] || 6;
      curPrinter.project.progress = payload.data.progress;
      curPrinter.project.curr_layer = payload.data.curr_layer;
      curPrinter.project.total_layers = payload.data.total_layers;
      curPrinter.project.remain_time = payload.data.remain_time;
      curPrinter.project.task_id = payload.data.taskid;
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (
      payload.state == "checking" ||
      payload.state == "failed" ||
      payload.state == "waiting" ||
      payload.state == "auto_leveling" ||
      payload.state == "vibrating" ||
      payload.state == "flow_calibrating" ||
      payload.state == "drying"
    ) {
      curPrinter.project.task_id = payload.data.taskid;
      curPrinter.project.print_status = map[payload.state];
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == "downloading") {
      curPrinter.project.task_id = payload.data.taskid;
      curPrinter.project.print_status = map[payload.state];
      curPrinter.project.progress = payload.data.progress;
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == "stopping") {
      store.dispatch("SET_LOADING_FALSE");
      curPrinter.project.pause = 4;
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == 'updated') {
      let curTask = store.getters.GET_CUR_TASK;
      if (curTask && curTask.key == modelKey) {
        if (curTask.id == payload.data.taskid) {
          curTask.temp.curr_hotbed_temp = payload.data.curr_hotbed_temp;
          curTask.temp.curr_nozzle_temp = payload.data.curr_nozzle_temp;
          curTask.temp.target_hotbed_temp =
            payload.data.settings?.target_hotbed_temp;
          curTask.temp.target_nozzle_temp =
            payload.data.settings?.target_nozzle_temp;
          curTask.fan_speed_pct = payload.data.settings?.fan_speed_pct;
          curTask.aux_fan_speed_pct = payload.data.settings?.aux_fan_speed_pct;
          curTask.box_fan_level = payload.data.settings?.box_fan_level;
          curTask.print_speed_mode = payload.data.settings?.print_speed_mode;
          store.commit("SET_CUR_TASK", curTask);
        }
      }
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    console.log("进了start", payload);
    if (!cloudList[idx].project) {
      Vue.set(cloudList[idx], "project", {});
    }
    if (
      payload.state == "preheating" ||
      payload.state == "printing" ||
      payload.state == "finished"
    ) {
      cloudList[idx].project.filename = payload.data.filename;
      // cloudList[idx].project.img = payload.data.img || "";
      cloudList[idx].project.estimate =
        (parseInt(payload.data.print_time) +
          parseInt(payload.data.remain_time)) *
        60; //
      // cloudList[idx].project.supplies_usage = payload.data.supplies_usage;
      cloudList[idx].project.pause = 0;
      cloudList[idx].project.print_status = map[payload.state] || 6;
      cloudList[idx].project.progress = payload.data.progress;
      cloudList[idx].project.curr_layer = payload.data.curr_layer;
      cloudList[idx].project.total_layers = payload.data.total_layers;
      cloudList[idx].project.remain_time = payload.data.remain_time;
      cloudList[idx].project.task_id = payload.data.taskid;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    } else if (
      payload.state == "checking" ||
      payload.state == "failed" ||
      payload.state == "waiting"
    ) {
      cloudList[idx].project.task_id = payload.data.taskid;
      cloudList[idx].project.print_status = map[payload.state];
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    } else if (payload.state == "downloading") {
      cloudList[idx].project.task_id = payload.data.taskid;
      cloudList[idx].project.print_status = map[payload.state];
      cloudList[idx].project.progress = payload.data.progress;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    } else if (payload.state == "stopping") {
      store.dispatch("SET_LOADING_FALSE");
      cloudList[idx].project.pause = 4;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
  }
}

// 操作vuex数据
function stopFun(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
  if (curPrinter && curPrinter.key == modelKey) {
    if (payload.state == "stopping") {
      store.dispatch("SET_LOADING_FALSE");
      curPrinter.project.pause = 4;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (payload.state == "stoped") {
      store.dispatch("SET_LOADING_FALSE");
      curPrinter.project = undefined;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }
  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    if (payload.state == "stopping") {
      console.log("进了stopping");
      store.dispatch("SET_LOADING_FALSE");
      cloudList[idx].project.pause = 4;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
    if (payload.state == "stoped") {
      console.log("进了stoped");
      store.dispatch("SET_LOADING_FALSE");
      cloudList[idx].project = undefined;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
  }
}

function pauseFun(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
  if (curPrinter && curPrinter.key == modelKey) {
    if (payload.state == "pausing") {
      console.log("进了pausing");
      store.dispatch("SET_LOADING_FALSE");
      curPrinter.project.pause = 2;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (payload.state == "paused") {
      console.log("进了paused");
      store.dispatch("SET_LOADING_FALSE");
      curPrinter.project.pause = 1;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    if (payload.state == "pausing") {
      console.log("进了pausing");
      store.dispatch("SET_LOADING_FALSE");
      cloudList[idx].project.pause = 2;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
    if (payload.state == "paused") {
      console.log("进了paused");
      store.dispatch("SET_LOADING_FALSE");
      cloudList[idx].project.pause = 1;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
  }
}

function resumeFun(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
  if (curPrinter && curPrinter.key == modelKey) {
    if (payload.state == "resuming") {
      console.log("进了resuming");
      store.dispatch("SET_LOADING_FALSE");
      curPrinter.project.pause = 3;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (payload.state == "resumed") {
      console.log("进了resumed");
      store.dispatch("SET_LOADING_FALSE");
      curPrinter.project.pause = 0;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    if (payload.state == "resuming") {
      console.log("进了resuming");
      store.dispatch("SET_LOADING_FALSE");
      cloudList[idx].project.pause = 3;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
    if (payload.state == "resumed") {
      console.log("进了resumed");
      store.dispatch("SET_LOADING_FALSE");
      cloudList[idx].project.pause = 0;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
  }
}

function updateVersion(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
  let map = {
    start: 1,
    downloading: 2,
    "update-success": 3,
    "update-failed": 4,
    "download-failed": 5,
    updating: 6
  };
  if (curPrinter && curPrinter.key == modelKey) {
    console.log("进了updateVersion", payload);
    curPrinter.version.need_update = 2;
    if (!curPrinter.version.updateStatus) {
      Vue.set(curPrinter.version, "updateStatus", "");
    }
    if (!curPrinter.version.progress) {
      Vue.set(curPrinter.version, "progress", "");
    }
    if (
      payload.state == "start" ||
      payload.state == "update-failed" ||
      payload.state == "download-failed"
    ) {
      curPrinter.version.updateStatus = map[payload.state];
      curPrinter.version.progress = "";
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == "updating") {
      curPrinter.version.updateStatus = map[payload.state];
      curPrinter.version.progress = payload.data.current_progress;
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == "downloading") {
      curPrinter.version.updateStatus = map[payload.state];
      curPrinter.version.progress = payload.data.progress;
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == "update-success") {
      curPrinter.version.updateStatus = map[payload.state];
      curPrinter.version.progress = "";
      curPrinter.version.firmware_version = curPrinter.version.target_version;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    console.log("进了updateVersion", payload);
    cloudList[idx].version.need_update = 2;
    if (!cloudList[idx].version.updateStatus) {
      Vue.set(cloudList[idx].version, "updateStatus", "");
    }
    if (!cloudList[idx].version.progress) {
      Vue.set(cloudList[idx].version, "progress", "");
    }
    if (
      payload.state == "start" ||
      payload.state == "update-failed" ||
      payload.state == "download-failed"
    ) {
      cloudList[idx].version.updateStatus = map[payload.state];
      cloudList[idx].version.progress = "";
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    } else if (payload.state == "updating") {
      cloudList[idx].version.updateStatus = map[payload.state];
      cloudList[idx].version.progress = payload.data.current_progress;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    } else if (payload.state == "downloading") {
      cloudList[idx].version.updateStatus = map[payload.state];
      cloudList[idx].version.progress = payload.data.progress;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    } else if (payload.state == "update-success") {
      cloudList[idx].version.updateStatus = map[payload.state];
      cloudList[idx].version.progress = "";
      cloudList[idx].version.firmware_version =
        curPrinter.version.target_version;
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
  }
}

function updateCancel(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));

  if (curPrinter && curPrinter.key == modelKey) {
    if (!curPrinter.version.updateStatus) {
      Vue.set(curPrinter.version, "updateStatus", "");
    }
    if (payload.state == "canceled") {
      curPrinter.version.updateStatus = 7;
      curPrinter.version.progress = "";
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    if (!cloudList[idx].version.updateStatus) {
      Vue.set(cloudList[idx].version, "updateStatus", "");
    }
    if (payload.state == "canceled") {
      cloudList[idx].version.updateStatus = 7;
      cloudList[idx].version.progress = "";
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
  }
}

// function updateReport(modelKey,payload) {
//   let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));

//   if(curPrinter && curPrinter.key == modelKey && payload.type == 'ota'  && payload.action == 'reportVersion') {
//     if(payload.state == 'report-success') {
//       curPrinter.version.firmware_version = payload.data.firmware_version;
//       store.commit('SET_CUR_PRINTER', curPrinter)
//     }
//   }
// }

function updateBoxVersion(modelKey, boxid, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
  let map = {
    start: 1,
    downloading: 2,
    "update-success": 3,
    "update-failed": 4,
    "download-failed": 5,
    updating: 6
  };
  if (curPrinter && curPrinter.key == modelKey) {
    console.log("进了updateVersion", payload);
    let index = curPrinter.multi_color_box_version.findIndex(
      (item) => item.box_id == boxid
    );
    if (index != -1) {
      curPrinter.multi_color_box_version[index].need_update = 2;
      if (!curPrinter.multi_color_box_version[index].updateStatus) {
        Vue.set(curPrinter.multi_color_box_version[index], "updateStatus", "");
      }
      if (!curPrinter.multi_color_box_version[index].progress) {
        Vue.set(curPrinter.multi_color_box_version[index], "progress", "");
      }
      if (
        payload.state == "start" ||
        payload.state == "update-failed" ||
        payload.state == "download-failed"
      ) {
        curPrinter.multi_color_box_version[index].updateStatus =
          map[payload.state];
        curPrinter.multi_color_box_version[index].progress = "";
        store.commit("SET_CUR_PRINTER", curPrinter);
      } else if (payload.state == "updating") {
        curPrinter.multi_color_box_version[index].updateStatus =
          map[payload.state];
        curPrinter.multi_color_box_version[index].progress =
          payload.data.current_progress;
        store.commit("SET_CUR_PRINTER", curPrinter);
      } else if (payload.state == "downloading") {
        curPrinter.multi_color_box_version[index].updateStatus =
          map[payload.state];
        curPrinter.multi_color_box_version[index].progress =
          payload.data.progress;
        store.commit("SET_CUR_PRINTER", curPrinter);
      } else if (payload.state == "update-success") {
        curPrinter.multi_color_box_version[index].updateStatus =
          map[payload.state];
        curPrinter.multi_color_box_version[index].progress = "";
        curPrinter.multi_color_box_version[index].firmware_version =
          curPrinter.multi_color_box_version[index].target_version;
        store.commit("SET_CUR_PRINTER", curPrinter);
      }
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    console.log("进了updateVersion", payload);
    let index = cloudList[idx].multi_color_box_version.findIndex(
      (item) => item.box_id == boxid
    );
    if (index != -1) {
      cloudList[idx].multi_color_box_version[index].need_update = 2;
      if (!cloudList[idx].multi_color_box_version[index].updateStatus) {
        Vue.set(
          cloudList[idx].multi_color_box_version[index],
          "updateStatus",
          ""
        );
      }
      if (!cloudList[idx].multi_color_box_version[index].progress) {
        Vue.set(cloudList[idx].multi_color_box_version[index], "progress", "");
      }
      if (
        payload.state == "start" ||
        payload.state == "update-failed" ||
        payload.state == "download-failed"
      ) {
        cloudList[idx].multi_color_box_version[index].updateStatus =
          map[payload.state];
        cloudList[idx].multi_color_box_version[index].progress = "";
        store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
      } else if (payload.state == "updating") {
        cloudList[idx].multi_color_box_version[index].updateStatus =
          map[payload.state];
        cloudList[idx].multi_color_box_version[index].progress =
          payload.data.current_progress;
        store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
      } else if (payload.state == "downloading") {
        cloudList[idx].multi_color_box_version[index].updateStatus =
          map[payload.state];
        cloudList[idx].multi_color_box_version[index].progress =
          payload.data.progress;
        store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
      } else if (payload.state == "update-success") {
        cloudList[idx].multi_color_box_version[index].updateStatus =
          map[payload.state];
        cloudList[idx].multi_color_box_version[index].progress = "";
        cloudList[idx].multi_color_box_version[index].firmware_version =
          cloudList[idx].multi_color_box_version[index].target_version;
        store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
      }
    }
  }
}

function updateBoxCancel(modelKey, boxid, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));

  if (curPrinter && curPrinter.key == modelKey) {
    let index = curPrinter.multi_color_box_version.findIndex(
      (item) => item.box_id == boxid
    );
    if (index != -1) {
      if (!curPrinter.multi_color_box_version[index].updateStatus) {
        Vue.set(curPrinter.multi_color_box_version[index], "updateStatus", "");
      }
      if (payload.state == "canceled") {
        curPrinter.multi_color_box_version[index].updateStatus = 7;
        curPrinter.multi_color_box_version[index].progress = "";
        store.commit("SET_CUR_PRINTER", curPrinter);
      }
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    let index = cloudList[idx].multi_color_box_version.findIndex(
      (item) => item.box_id == boxid
    );
    if (index != -1) {
      if (!cloudList[idx].multi_color_box_version[index].updateStatus) {
        Vue.set(
          cloudList[idx].multi_color_box_version[index],
          "updateStatus",
          ""
        );
      }
      if (payload.state == "canceled") {
        cloudList[idx].multi_color_box_version[index].updateStatus = 7;
        cloudList[idx].multi_color_box_version[index].progress = "";
        store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
      }
    }
  }
}

function workReport(modelKey, payload) {
  console.log("进入了workReport", payload);
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
  if (curPrinter && curPrinter.key == modelKey) {
    if (payload.state == "free") {
      curPrinter.device_status = "1";
      curPrinter.is_printing = "1";
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (payload.state == "busy") {
      curPrinter.device_status = "1";
      curPrinter.is_printing = "2";
      store.commit("SET_CUR_PRINTER", curPrinter);
    }

    if (payload.state == "offline") {
      curPrinter.device_status = "2";
      curPrinter.is_printing = "1";
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  // 处理列表
  let cloudList = JSON.parse(
    JSON.stringify(store.getters.GET_CLOUD_PRINTER_LIST)
  );
  let idx = cloudList.findIndex((item) => modelKey == item.key);
  if (idx != -1) {
    if (payload.state == "free") {
      cloudList[idx].device_status = "1";
      cloudList[idx].is_printing = "1";
      cloudList = px(cloudList);
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
    if (payload.state == "busy") {
      cloudList[idx].device_status = "1";
      cloudList[idx].is_printing = "2";
      cloudList = px(cloudList);
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
    if (payload.state == "offline") {
      cloudList[idx].device_status = "2";
      cloudList[idx].is_printing = "1";
      cloudList = px(cloudList);
      store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
    }
  }
}

//  当前错误码数组后端返回四国语言，要根据当前页面语言进行映射，其他过返回英文
function returnMessage(obj) {
  //  获取当前页面语言，进行映射
  const language = i18n.locale
  let str = ''
  switch (language) {
    case 'zh_CN':
      str = 'cn'
      break
    case 'zh_TW':
      str = 'zh'
      break
    case 'en':
      str = 'en'
      break
    case 'ru':
      str = 'ru'
      break
    case 'de':
      str = 'de'
      break
    default:
      str = 'en'
      break
  }
  return obj[`desc_${str}`]
}

//  获取到错误信息后需要做额外处理
function errorAfter(key, code) {
  //  判断是否当前机器
  const curPrinter = store.getters['GET_CUR_PRINTER'] || {}
  if (curPrinter.key === key && (code == 10347 || code == 10348 || code == 10349)) {
    materialsAll('light')
  }
}
